<!-- <app-nav-bar></app-nav-bar> -->
@if (loaded() && ds().orgUser) {
  <div class="main">
    <div class="profile-background" [ngStyle]="{ 'background-image': 'url(' + ds().theming?.banner + ')' }">
      @if (ds().orgUser.name) {
        <h1 class="profile-name">
          <div class="avatar-placeholder">
            {{ ds().orgUser.name[0] }}
          </div>
          {{ ds().orgUser.name }}
        </h1>
      }
    </div>
    <mat-tab-group>
      @if (ds().orgUser) {
        <mat-tab class="tab-full-height" label="Tegoed en gebruik">
          <app-balance [orgUserHistory]="orgUserHistory()"></app-balance>
        </mat-tab>
      }
      @if (ds().orgUser && ds().orgUser) {
        <mat-tab class="tab-full-height" label="Profiel">
          <app-profile-content></app-profile-content>
        </mat-tab>
      }
    </mat-tab-group>
  </div>
}
@if (!loaded() || !ds().orgUser) {
  <div class="loading-wrapper" role="status" aria-live="polite" aria-atomic="true">
    <div class="loading">
      <mat-spinner></mat-spinner>
    </div>
  </div>
}
